// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"622":"91c310c4875cd17a819f","628":"2c1b5bcf1a24aa21a7af"}[chunkId] + "-2.0.0.js";
};